var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleInfoSolid = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5C18.0078 2.5 22.5 6.99219 22.5 12.5C22.5 18.0469 18.0078 22.5 12.5 22.5C6.95312 22.5 2.5 18.0469 2.5 12.5C2.5 6.99219 6.95312 2.5 12.5 2.5ZM12.5 7.5C11.7969 7.5 11.25 8.08594 11.25 8.75C11.25 9.45312 11.7969 10 12.5 10C13.1641 10 13.75 9.45312 13.75 8.75C13.75 8.08594 13.1641 7.5 12.5 7.5ZM14.0625 17.5C14.5703 17.5 15 17.1094 15 16.5625C15 16.0547 14.5703 15.625 14.0625 15.625H13.4375V12.1875C13.4375 11.6797 13.0078 11.25 12.5 11.25H11.25C10.7031 11.25 10.3125 11.6797 10.3125 12.1875C10.3125 12.7344 10.7031 13.125 11.25 13.125H11.5625V15.625H10.9375C10.3906 15.625 10 16.0547 10 16.5625C10 17.1094 10.3906 17.5 10.9375 17.5H14.0625Z",
    fill: "#ffffff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleInfoSolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-info-solid.e061109f814b30471952c9a6c622eb32.svg";